import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  /**
   * @constructor
   */
  constructor() { }

  /**
   * Obtiene elementos guardados en el localStorage
   * @param {string} key 
   * @returns 
   */
  public getItem(key: string): any {
    return JSON.parse(localStorage.getItem(key));
  }

  /**
   * Guarda elementos en el localStorage
   * @param {atring} key 
   * @param {T} data 
   * @returns {void}
   */
  public setItem<T>(key: string, data: T): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  /**
   * Elimina elementos en el localStorage
   * @param {string} key 
   * @returns {void}
   */
  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }
  
  /**
   * Limpia el localStorage
   * @returns {void}
   */
  private clearLocalStorage(): void {
    localStorage.clear();
  }
}
